import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ScanHistoryItem,
  ScanHistoryResponse,
  ScanHistoryByIdItem,
} from "../../types/pages/prodseals";

interface ScanHistoryState {
  items: ScanHistoryItem[];
  loading: boolean;
  error: string | null;
  page: number;
  rowsPerPage: number;
  totalCount: number;
  sortBy: string;
  sortOrder: number;

  scanItems: ScanHistoryByIdItem | null;
  scanLoading: boolean;
  scanError: string | null;
}

const initialState: ScanHistoryState = {
  items: [],
  loading: false,
  error: null,
  page: 0,
  rowsPerPage: 10,
  totalCount: 0,
  sortBy: "created_at",
  sortOrder: -1,

  scanItems: null,
  scanLoading: false,
  scanError: null,
};

const scanHistorySlice = createSlice({
  name: "scanHistory",
  initialState,
  reducers: {
    fetchScanHistory: (
      state,
      action: PayloadAction<{
        page: number;
        rowsPerPage: number;
        sortBy?: string;
        sortOrder?: number;
        possible_counterfeit?: boolean;
      }>,
    ) => {},
    fetchScanHistoryStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchScanHistorySuccess: (
      state,
      action: PayloadAction<ScanHistoryResponse>,
    ) => {
      state.loading = false;
      state.items = action.payload.data;
      state.totalCount = action.payload.total;
    },
    fetchScanHistoryFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchScanHistoryById: (state, action: PayloadAction<{ _id: string }>) => {},
    fetchScanHistoryByIdStart: (state) => {
      state.scanLoading = true;
      state.scanError = null;
    },
    fetchScanHistoryByIdSuccess: (state, action: PayloadAction<any>) => {
      state.scanLoading = false;
      state.scanItems = action.payload;
    },
    fetchScanHistoryByIdFailure: (state, action: PayloadAction<string>) => {
      state.scanLoading = false;
      state.scanError = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
      state.page = 0;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
      state.page = 0;
    },
    setSortOrder: (state, action: PayloadAction<number>) => {
      state.sortOrder = action.payload;
      state.page = 0;
    },
    resetScanHistory: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  fetchScanHistory,
  fetchScanHistoryStart,
  fetchScanHistorySuccess,
  fetchScanHistoryFailure,
  fetchScanHistoryById,
  fetchScanHistoryByIdStart,
  fetchScanHistoryByIdSuccess,
  fetchScanHistoryByIdFailure,
  setPage,
  setRowsPerPage,
  setSortBy,
  setSortOrder,
  resetScanHistory,
} = scanHistorySlice.actions;

export default scanHistorySlice.reducer;
